import { object, string, func } from 'prop-types';
import { Field } from 'react-final-form';
import cn from 'classnames';

import styles from './FormInput.module.scss';

function FormInput(props) {
  const {
    input,
    meta: { active, error, touched },
    label,
    onChange,
    onFocus,
    onBlur,
    className,
    autoFocus,
    ...rest
  } = props;

  return (
    <div
      className={cn(styles.formInput, {
        [styles[className]]: !!className,
      })}
    >
      <label
        className={cn(styles.formInput__label, {
          [styles['formInput__label--is-floating']]: active || input.value || autoFocus,
        })}
      >
        {label}
      </label>
      <div className={cn(styles.formInput__box)}>
        <input
          {...rest}
          {...input}
          autoFocus={autoFocus}
          onChange={onChange}
        />
        <div className={cn(styles.formInput__border)}></div>
      </div>
      {touched && error && <div className={cn(styles.formInput__error)}>{error}</div>}
    </div>
  );
}

FormInput.propTypes = {
  input: object,
  meta: object,
  label: string,
  onBlur: func,
  onFocus: func,
  className: string,
  type: string,
  name: string.isRequired,
};

FormInput.defaultProps = {
  type: 'text',
  autoFocus: false
};

const _FormInput = ({ name, ...rest }) => (
  <Field name={name}>
    {({ input, meta }) => {
      return (
        <FormInput
          {...rest}
          name={name}
          input={input}
          meta={meta}
          onChange={(e) => {
            input.onChange(e); //final-form's onChange
          }}
        />
      );
    }}
  </Field>
);
export default _FormInput;
